import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

const Footer = () => {
  const { city, county, state, label } =
    useSelector(s => s.local?.location) || {};
  const display = city || county || state || label || 'California';

  return (
    <footer className="site-footer">
      <div className="footer-container">
        <div className="footer-left">
          <h3>We Are Local</h3>
          <p>Connecting Our Community Through News, Events, and Collaboration</p>
          <small>Current local: {display}</small>
        </div>

        <div className="footer-links">
          <Link to="/about">About</Link>
          <Link to="/contact">Contact</Link>
          <Link to="/privacy">Privacy Policy</Link>
          <a href="https://profylist.com" target="_blank" rel="noopener noreferrer">Profylist</a>
        </div>

        <div className="footer-right">
          <p>&copy; {new Date().getFullYear()} We Are Local. All rights reserved</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;